var checkMax = 0
window.loadedCallouts = setInterval(function () {
  if (window.boostPFS !== undefined 
      && window.boostPFS.filter.isRendered 
      && window.masterCalloutsData !== undefined
      && window.Globals.queryParams.page !== undefined
      && window.ProductList !== undefined ) {
        
        window.collectionCallouts = {
          masterCalloutsData : window.masterCalloutsData,
          currPage           : window.Globals.queryParams.page,
          productsPerPage    : window.Globals.queryParams.limit,
          gridWrapperClass   : '.boost-pfs-filter-products',
          callouts           : [],
      
          /**
           * @summary Initializes the collection callpouts functionality
           * 
           * @description Waits on doc ready to init
           *
           * @return  {void}
           */
          init: function () {
            var self = this;
      
            // No callouts
            if( self.masterCalloutsData.length === 0 )
              return;

            // Add event listeners
            self.addEventListeners();
      
            // Place callouts
            self.insertCallouts();

            // Adjust positioning
            self.positionCallouts();
          },
          
          /**
           * @summary Adds necessary event listeners
           * 
           * @description Creates the necessary event
           * listeners required for this functionality.
           *
           * @return  {void}
           */
          addEventListeners: function () {
            var self = this;

            // Add class to wrapper
            if( self.masterCalloutsData.length )
              $(self.gridWrapperClass).addClass('callouts-grid');

            // Page change
            $(document).on('click', '.boost-pfs-filter-bottom-pagination li', function () {
              window.ProductList.prototype.afterRender = function() {
                if( self.currPage !== window.Globals.queryParams.page ) {
                  self.currPage = parseInt(window.Globals.queryParams.page);
                  
                  $('.plp_callout').each(function() {
                    if( parseInt( $(this).attr('data-page') ) !== self.currPage ) {
                      $(this).remove();
                      console.log('REMOVED');
                    }
                  });

                  self.insertCallouts();
                  self.positionCallouts();
                }
              }
            });

            var posRunning;

            window.onresize = function(){
              clearTimeout(posRunning);
              posRunning = setTimeout(self.positionCallouts(), 100);
            };
          },
          
          /**
           * @summary Checks and ensures placement
           * 
           * @description Checks that the current position
           * works and if it doesn't it moves the callout 
           * as needed depeneding on modulus.
           *
           * @return  {void}
           */
          positionCallouts: function () {
            var self      = this;
            // var totalCols = window.innerWidth < 992 ? 2 : ( window.innerWidth >= 1390 ? 4 : 3 );

            $('.plp_callout').remove();

            self.callouts.map(c => {
              
              // var items   = $('.grid_row .product_card').length - ($('.grid_row .plp_callout').length * 2);
              var cards      = $('.grid_row .product_card');
              var pos        = parseInt( c.attr('data-position'));
              var page       = parseInt( c.attr('data-page'));
              // var currCol = currRow = 1;

              if( page === self.currPage )
                c.insertBefore(cards.eq(pos - 1));

              // for (let i = 1; i < items; i++, currCol++) {

              //   if( cards.eq(i - 1).attr('data-position') !== undefined ) {
              //     currCol++; i++;
              //   }

              //   if( currCol > totalCols ) {
              //     currCol = 1; currRow++;
              //   }

              //   if( i >= pos ) {
              //     if( currCol && currCol !== totalCols ) {
              //       if( totalCols === 2 && currCol === 2 )
              //         continue;
                    
              //       if( totalCols === 3 && cards.eq( i - 2 ).attr('data-position') !== undefined )
              //         continue;
                    
              //       ( totalCols == 2 && (cards.eq(i - 1).prevAll('.product_card').length + (cards.eq(i - 1).prevAll('.plp_callout').length * 2)) % totalCols !== 0 ) ? c.insertBefore(cards.eq(i - 2)) : c.insertBefore(cards.eq(i - 1));
              //       return
              //     }
              //   }
              // }
            })
          },
          
          /**
           * @summary Parses metafields
           * 
           * @description Loops through the defined
           * fields in MetaGuru and creates a structured
           * object.
           *
           * @return  {void}
           */
          insertCallouts: function () {
            var self            = this;
            var currMaxPosition = self.productsPerPage * self.currPage;
            self.callouts       = [];

            // Insert callouts
            self.masterCalloutsData.map((callout, i) => {
              // Get Int instead of string
              callout.position = parseInt(callout.position);

              // Right page?
              if( callout.position > currMaxPosition )
                return;

              // Make sure it is not a zero position
              if( callout.position === 0 )
                callout.position++;

              // Determine which page this callout will be on
              if( callout.page === undefined )
                callout.page = Math.ceil(callout.position / self.productsPerPage);

              // Filter position so its on the current page
              if( callout.position > self.productsPerPage )
                callout.position = callout.position - ( (callout.page - 1) * self.productsPerPage );

              // Add if the right page
              if( self.currPage === callout.page ) {
                var calloutHtml = self.buildHtml(callout);
                self.callouts.push($(calloutHtml));
              }
            });
          },

          /**
           * @summary Creates the callout HTML
           * 
           * @description Builds the callout HTML using
           * the provided params
           *
           * @return  {void}
           */
          buildHtml: function (callout) {
            var self = this;

            return `
              <div id="callout_${callout.position}" data-page=${callout.page} data-position=${callout.position} class="card plp_callout">
                ${(callout.image !== undefined || callout.background !== undefined) 
                  ? `<div class="card-text text-center" 
                          style="
                            ${callout.image !== undefined ? `background-image: url('${callout.image}')` : `background-color: ${callout.background}`}; 
                            ${callout.fontSize !== undefined ? `font-size: ${callout.fontSize};` : ''}">
                      ${callout.text !== undefined 
                        ? `${callout.link !== undefined 
                             ? `<a ${callout.textColor !== undefined ? `style="color: ${callout.textColor};"` : ''} href="${callout.link}" class="stretched-link">${callout.text}</a>` 
                             : `<span>${callout.text}</span>`
                            }`
                        : ``
                        }
                    </div>` 
                  : ``
                }
                ${callout.link !== undefined && callout.cta !== undefined 
                  ? `<div class="card-body text-right">
                      <a href="${callout.link}" class="stretched-link">${callout.cta}</a>
                    </div>` 
                  : ``
                }
              </div>
            `;
          },
        };

        collectionCallouts.init();
        clearInterval(window.loadedCallouts);
      }

  if (checkMax >= 15)
    (console.log('Error! - Could not load callout tools.'), clearInterval(window.loadedCallouts));
  
  checkMax++;
}, 300);
